import { useEffect, useState } from "react";

export default function ContextState() {
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [site_title, set_site_title] = useState("MK Medical");
  const [menuShow, setMenuShow] = useState(true);
  const [lineData, setLineData] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  const userDataTest1 = { "data_main": { "ID": 1, "MOBILE": "0811191797", "LINE_NAME": "Gear", "LINE_TOKEN": "U2188005926cde56b960e05b56c6b12df", "LINE_IMG": "https://profile.line-scdn.net/0hCgss2D_THEheCg0am9JiNy5aHyJ9e0VaJWVbL2hZEnhjal5McmpbL25ZRHFjPloecmlWKTkNEn9SGWsuQFzgfFk6QXliPV0bd2RWrA", "INSERT_DT": null } }
  const userDataTest2 = { "data_main": { "ID": 3, "MOBILE": "0864915265", "LINE_NAME": "Gear", "LINE_TOKEN": "U2188005926cde56b960e05b56c6b12df", "LINE_IMG": "https://profile.line-scdn.net/0hCgss2D_THEheCg0am9JiNy5aHyJ9e0VaJWVbL2hZEnhjal5McmpbL25ZRHFjPloecmlWKTkNEn9SGWsuQFzgfFk6QXliPV0bd2RWrA", "INSERT_DT": "2025-01-20T07:31:28.000Z" } }

  useEffect(() => {
    // setUserData(userDataTest1)
  }, [])
  return {
    userData, setUserData,
    isLoading, setIsLoading,
    site_title, set_site_title,
    menuShow, setMenuShow,
    lineData, setLineData,
    isPlaying, setIsPlaying,
    hasInteracted, setHasInteracted
  };
}
